<template>
  <layout :width="1024">
    <div class="main-page">
      <div class="content-wrapper">
        <back-button to="/" />

        <br />
        <br />

        <h2>{{ 'house.mainPage.title' | i18n }}</h2>
        <div v-html="$options.filters.i18n('house.mainPage.description')"></div>

        <info-steps
          :step1="'house.info.step1' | i18n"
          :step2="'house.info.step2' | i18n"
          :step3="'house.info.step3' | i18n"/>
        <br />

        <div>
          <h3>{{ 'house.mainPage.step1.title' | i18n }}</h3>
          <p>{{ 'house.mainPage.step1.description' | i18n }}</p>

          <house-params />
          <br />
        </div>

        <div>
          <h3>{{ 'house.mainPage.step2.title' | i18n }}</h3>
          <p>{{ 'house.mainPage.step2.description' | i18n }}</p>

          <div class="form-group">
            <label for="operation-description">
              {{ 'common.mainPage.operationDescription.label' | i18n }}
            </label>
            <textarea id="operation-description" class="form-control" v-model="description"
                      :placeholder="'common.mainPage.operationDescription.placeholder' | i18n"></textarea>
          </div>

          <h4>Valitse korjaustoimenpide</h4>
          <operation-list
            category="talo"
            :operationTypes="operationTypes"
            :paramsComplete="isComplete"
            @operationTypeChanged="onOperationTypeChanged"
            @operationSelected="onOperationSelected"/>
        </div>


        <br />
        <back-button to="/" />
      </div>
    </div>
  </layout>
</template>


<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import Layout from './Layout'
  import OperationList from './OperationList'
  import InfoSteps from './InfoSteps'
  import HouseParams from './HouseParams'
  import calculationService from "../api/calculationService"
  import { houseOperationTypes } from '../api/constants'

  export default {
    props: [
      'calculationId'
    ],

    methods: {
      onOperationTypeChanged(operationType) {
        this.$store.commit('houseParams/SET_OPERATION_TYPE', operationType)
      },

      onOperationSelected(operation) {
        calculationService.updateCalculation('house', this.calculationId, {
          params: this.apiParams,
          selectedOperationId: operation.id
        })
          .then(() => this.$router.push('/talo/' + this.calculationId + '/tulos'))
      }
    },

    computed: {
      ...mapGetters('houseParams', [
        'isComplete', 'apiParams'
      ]),
      description: {
        get() {
          return this.$store.state.houseParams.description
        },
        set(description) {
          return this.$store.commit('houseParams/SET_DESCRIPTION', description)
        }
      },
      operationType: {
        get() {
          return this.$store.state.houseParams.operationType
        },
        set(operationType) {
          return this.$store.commit('houseParams/SET_OPERATION_TYPE', operationType)
        }
      }
    },

    data() {
      return {
        operation: [],
        operationTypes: houseOperationTypes
      }
    },

    created () {
      // fetch calculation with calculationId (will be created if it doesn't exist)
      calculationService.getCalculation('house', this.calculationId)
        .then(calculation => {
          // if calculation has saved parameters, load those
          if(calculation.params.saved) {
            this.$store.commit('houseParams/SET_FROM_CALCULATION', calculation)
          }
          else {
            this.$store.commit('houseParams/CLEAR')
          }
        })
    },

    components: {
      Layout,
      OperationList,
      InfoSteps,
      HouseParams
    }
  }
</script>

<style scoped>
  .main-page {
    background-image: url("../assets/layout/brownTexture.jpg");
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HouseMainPage.vue